//Snackbar.js
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite";
import CloseIcon from "@material-ui/icons/Close";
import WarningIcon from "@material-ui/icons/Warning";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import Info from "@material-ui/icons/Info";
import MuiAlert from '@material-ui/lab/Alert';
import SnackbarUI from "@material-ui/core/Snackbar";
import Button from "@material-ui/core/Button";

const styles = StyleSheet.create({
	messageSpan: {
		display: "flex",
		flex: 1,
		justifyContent: "center",
		alignItems: "center"
	},
	icon: {
		marginRight: "10px"
	}
});

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

class Snackbar extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
            message: "",
            severity: "info"
		};
		Snackbar.show = msg => {
			this.open(msg);
		};
		Snackbar.info = msg => {
			this.open(msg, "info");
		};
		Snackbar.error = msg => {
			this.open(msg, "error");
		};
		Snackbar.warning = msg => {
			this.open(msg, "warning");
		};
	}

	onClose(event, reason) {
		if (reason === "clickaway") {
			return;
		}

		this.setState({ open: false });
	}

	open(msg, severity = "info") {
		this.setState({ open: true, message: msg, severity: severity });
	}

	render() {
		return (
			<SnackbarUI
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left"
				}}
				key={this.props.oKey}
				open={this.state.open}
				autoHideDuration={6000}
				onClose={this.onClose.bind(this)}
				SnackbarContentProps={{
					"aria-describedby": "message-id"
				}}
				message={<span id="message-id">{this.state.message}</span>}
				action={[
					<Button
						key="close"
						aria-label="Close"
						color="inherit"
						//className={css(styles.close)}
						onClick={this.onClose.bind(this)}
					>
						<CloseIcon />
					</Button>
				]}
			>
            <Alert onClose={this.onClose.bind(this)} severity={this.state.severity}>
                {this.state.message}
            </Alert>
            </SnackbarUI>
		);
	}
}

export default Snackbar;
